
/**
 * Cache to register public.branch
 * @kind cache
 * @class 
 * @description Custom lookup cache for 
 * @usage let lookup = await Grape.cache.get('BranchLookup');
 */
export default {
	name: 'BranchLookup',
	options: {
		schema: 'public',
		table: 'branch'
	}
};
